"use client";

import { useState, useEffect } from "react";
import BusinessHeader from "./BusinessHeader";
import ContactActions from "./ContactActions";
import BusinessInfo from "./BusinessInfo";
import PhotoGallery from "./PhotoGallery";
import ReviewsSection from "./ReviewsSection";
import ReportBusiness from "./ReportBusiness";

interface Business {
  id: number;
  name: string;
  category: string;
  verified: boolean;
  rating: number;
  reviewCount: number;
  image: string;
  alt: string;
  isOpen: boolean;
  phone: string;
  whatsapp: string;
  address: string;
  area: string;
  hours: {
    day: string;
    time: string;
  }[];
  services: string[];
  photos: {
    url: string;
    alt: string;
  }[];
  reviews: {
    id: number;
    userName: string;
    userImage: string;
    userImageAlt: string;
    rating: number;
    date: string;
    comment: string;
  }[];
}

export default function ServiceDetailsInteractive() {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  const mockBusiness: Business = {
    id: 1,
    name: "Sharma Medical Store",
    category: "Medical & Healthcare",
    verified: true,
    rating: 4.8,
    reviewCount: 60,
    image: "https://images.pexels.com/photos/4386467/pexels-photo-4386467.jpeg",
    alt: "Modern pharmacy interior with well-organized medicine shelves and bright lighting",
    isOpen: true,
    phone: "+919876543210",
    whatsapp: "919876543210",
    address: "Main Road, Near State Bank of India",
    area: "Kahalgaon, Bhagalpur, Bihar 813203",
    hours: [
      { day: "Monday - Saturday", time: "8:00 AM - 9:00 PM" },
      { day: "Sunday", time: "9:00 AM - 6:00 PM" },
    ],
    services: [
      "Prescription Medicines",
      "Over-the-Counter Drugs",
      "Medical Equipment",
      "Health Supplements",
      "First Aid Supplies",
      "Home Delivery Available",
      "24/7 Emergency Service",
      "Free Health Consultation",
    ],
    photos: [
      {
        url: "https://images.pexels.com/photos/4386467/pexels-photo-4386467.jpeg",
        alt: "Modern pharmacy interior with well-organized medicine shelves and bright lighting",
      },
      {
        url: "https://images.pexels.com/photos/3683041/pexels-photo-3683041.jpeg",
        alt: "Pharmacist in white coat organizing medicines on shelves in clean pharmacy",
      },
      {
        url: "https://images.pexels.com/photos/4386464/pexels-photo-4386464.jpeg",
        alt: "Close-up of medicine bottles and packages neatly arranged on pharmacy counter",
      },
      {
        url: "https://images.pexels.com/photos/5910956/pexels-photo-5910956.jpeg",
        alt: "Customer service counter with digital display and modern pharmacy equipment",
      },
    ],
    reviews: [
      {
        id: 1,
        userName: "Rajesh Kumar",
        userImage:
          "https://images.pexels.com/photos/2379004/pexels-photo-2379004.jpeg",
        userImageAlt:
          "Professional headshot of middle-aged Indian man with glasses in blue shirt",
        rating: 5,
        date: "2 days ago",
        comment:
          "Excellent service! The staff is very knowledgeable and helpful. They always have the medicines in stock and provide home delivery on time. Highly recommended for all medical needs.",
      },
      {
        id: 2,
        userName: "Priya Singh",
        userImage:
          "https://images.pexels.com/photos/3763188/pexels-photo-3763188.jpeg",
        userImageAlt:
          "Young Indian woman with long black hair smiling in traditional attire",
        rating: 5,
        date: "1 week ago",
        comment:
          "Very reliable medical store. The owner is very cooperative and provides genuine medicines. They also offer free health consultation which is really helpful.",
      },
      {
        id: 3,
        userName: "Amit Verma",
        userImage:
          "https://images.pexels.com/photos/1222271/pexels-photo-1222271.jpeg",
        userImageAlt:
          "Young Indian man in casual white t-shirt with friendly smile",
        rating: 4,
        date: "2 weeks ago",
        comment:
          "Good pharmacy with reasonable prices. Sometimes there's a wait during peak hours, but the service quality makes it worth it. They maintain proper hygiene standards.",
      },
    ],
  };

  if (!isHydrated) {
    return (
      <div data-component-id="src/app/service-details/components/ServiceDetailsInteractive.tsx:140:6" data-component-path="src/app/service-details/components/ServiceDetailsInteractive.tsx" data-component-line="140" data-component-end-line="153" data-component-file="ServiceDetailsInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22min-h-screen%20bg-background%20pt-20%20pb-12%22%7D" className="min-h-screen bg-background pt-20 pb-12">
        <div data-component-id="src/app/service-details/components/ServiceDetailsInteractive.tsx:141:8" data-component-path="src/app/service-details/components/ServiceDetailsInteractive.tsx" data-component-line="141" data-component-end-line="152" data-component-file="ServiceDetailsInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22container%20mx-auto%20px-4%22%7D" className="container mx-auto px-4">
          <div data-component-id="src/app/service-details/components/ServiceDetailsInteractive.tsx:142:10" data-component-path="src/app/service-details/components/ServiceDetailsInteractive.tsx" data-component-line="142" data-component-end-line="151" data-component-file="ServiceDetailsInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22animate-pulse%20space-y-6%22%7D" className="animate-pulse space-y-6">
            <div data-component-id="src/app/service-details/components/ServiceDetailsInteractive.tsx:143:12" data-component-path="src/app/service-details/components/ServiceDetailsInteractive.tsx" data-component-line="143" data-component-end-line="143" data-component-file="ServiceDetailsInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22h-96%20bg-muted%20rounded-lg%22%7D" className="h-96 bg-muted rounded-lg" />
            <div data-component-id="src/app/service-details/components/ServiceDetailsInteractive.tsx:144:12" data-component-path="src/app/service-details/components/ServiceDetailsInteractive.tsx" data-component-line="144" data-component-end-line="150" data-component-file="ServiceDetailsInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-1%20lg%3Agrid-cols-3%20gap-6%22%7D" className="grid grid-cols-1 lg:grid-cols-3 gap-6">
              <div data-component-id="src/app/service-details/components/ServiceDetailsInteractive.tsx:145:14" data-component-path="src/app/service-details/components/ServiceDetailsInteractive.tsx" data-component-line="145" data-component-end-line="148" data-component-file="ServiceDetailsInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22lg%3Acol-span-2%20space-y-6%22%7D" className="lg:col-span-2 space-y-6">
                <div data-component-id="src/app/service-details/components/ServiceDetailsInteractive.tsx:146:16" data-component-path="src/app/service-details/components/ServiceDetailsInteractive.tsx" data-component-line="146" data-component-end-line="146" data-component-file="ServiceDetailsInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22h-64%20bg-muted%20rounded-lg%22%7D" className="h-64 bg-muted rounded-lg" />
                <div data-component-id="src/app/service-details/components/ServiceDetailsInteractive.tsx:147:16" data-component-path="src/app/service-details/components/ServiceDetailsInteractive.tsx" data-component-line="147" data-component-end-line="147" data-component-file="ServiceDetailsInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22h-64%20bg-muted%20rounded-lg%22%7D" className="h-64 bg-muted rounded-lg" />
              </div>
              <div data-component-id="src/app/service-details/components/ServiceDetailsInteractive.tsx:149:14" data-component-path="src/app/service-details/components/ServiceDetailsInteractive.tsx" data-component-line="149" data-component-end-line="149" data-component-file="ServiceDetailsInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22h-64%20bg-muted%20rounded-lg%22%7D" className="h-64 bg-muted rounded-lg" />
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div data-component-id="src/app/service-details/components/ServiceDetailsInteractive.tsx:158:4" data-component-path="src/app/service-details/components/ServiceDetailsInteractive.tsx" data-component-line="158" data-component-end-line="190" data-component-file="ServiceDetailsInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22min-h-screen%20bg-background%20pt-20%20pb-12%22%7D" className="min-h-screen bg-background pt-20 pb-12">
      <div data-component-id="src/app/service-details/components/ServiceDetailsInteractive.tsx:159:6" data-component-path="src/app/service-details/components/ServiceDetailsInteractive.tsx" data-component-line="159" data-component-end-line="189" data-component-file="ServiceDetailsInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22container%20mx-auto%20px-4%22%7D" className="container mx-auto px-4">
        <div data-component-id="src/app/service-details/components/ServiceDetailsInteractive.tsx:160:8" data-component-path="src/app/service-details/components/ServiceDetailsInteractive.tsx" data-component-line="160" data-component-end-line="162" data-component-file="ServiceDetailsInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22mb-6%22%7D" className="mb-6">
          <BusinessHeader data-component-id="src/app/service-details/components/ServiceDetailsInteractive.tsx:161:10" data-component-path="src/app/service-details/components/ServiceDetailsInteractive.tsx" data-component-line="161" data-component-end-line="161" data-component-file="ServiceDetailsInteractive.tsx" data-component-name="BusinessHeader" data-component-content="%7B%22elementName%22%3A%22BusinessHeader%22%7D" business={mockBusiness} />
        </div>

        <div data-component-id="src/app/service-details/components/ServiceDetailsInteractive.tsx:164:8" data-component-path="src/app/service-details/components/ServiceDetailsInteractive.tsx" data-component-line="164" data-component-end-line="188" data-component-file="ServiceDetailsInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-1%20lg%3Agrid-cols-3%20gap-6%22%7D" className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <div data-component-id="src/app/service-details/components/ServiceDetailsInteractive.tsx:165:10" data-component-path="src/app/service-details/components/ServiceDetailsInteractive.tsx" data-component-line="165" data-component-end-line="179" data-component-file="ServiceDetailsInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22lg%3Acol-span-2%20space-y-6%22%7D" className="lg:col-span-2 space-y-6">
            <PhotoGallery data-component-id="src/app/service-details/components/ServiceDetailsInteractive.tsx:166:12" data-component-path="src/app/service-details/components/ServiceDetailsInteractive.tsx" data-component-line="166" data-component-end-line="166" data-component-file="ServiceDetailsInteractive.tsx" data-component-name="PhotoGallery" data-component-content="%7B%22elementName%22%3A%22PhotoGallery%22%7D" photos={mockBusiness.photos} />
            <BusinessInfo data-component-id="src/app/service-details/components/ServiceDetailsInteractive.tsx:167:12" data-component-path="src/app/service-details/components/ServiceDetailsInteractive.tsx" data-component-line="167" data-component-end-line="172" data-component-file="ServiceDetailsInteractive.tsx" data-component-name="BusinessInfo" data-component-content="%7B%22elementName%22%3A%22BusinessInfo%22%7D"
              address={mockBusiness.address}
              area={mockBusiness.area}
              hours={mockBusiness.hours}
              services={mockBusiness.services}
            />
            <ReviewsSection data-component-id="src/app/service-details/components/ServiceDetailsInteractive.tsx:173:12" data-component-path="src/app/service-details/components/ServiceDetailsInteractive.tsx" data-component-line="173" data-component-end-line="177" data-component-file="ServiceDetailsInteractive.tsx" data-component-name="ReviewsSection" data-component-content="%7B%22elementName%22%3A%22ReviewsSection%22%7D"
              reviews={mockBusiness.reviews}
              averageRating={mockBusiness.rating}
              totalReviews={mockBusiness.reviewCount}
            />
            <ReportBusiness data-component-id="src/app/service-details/components/ServiceDetailsInteractive.tsx:178:12" data-component-path="src/app/service-details/components/ServiceDetailsInteractive.tsx" data-component-line="178" data-component-end-line="178" data-component-file="ServiceDetailsInteractive.tsx" data-component-name="ReportBusiness" data-component-content="%7B%22elementName%22%3A%22ReportBusiness%22%7D" businessName={mockBusiness.name} />
          </div>

          <div data-component-id="src/app/service-details/components/ServiceDetailsInteractive.tsx:181:10" data-component-path="src/app/service-details/components/ServiceDetailsInteractive.tsx" data-component-line="181" data-component-end-line="187" data-component-file="ServiceDetailsInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22lg%3Acol-span-1%22%7D" className="lg:col-span-1">
            <ContactActions data-component-id="src/app/service-details/components/ServiceDetailsInteractive.tsx:182:12" data-component-path="src/app/service-details/components/ServiceDetailsInteractive.tsx" data-component-line="182" data-component-end-line="186" data-component-file="ServiceDetailsInteractive.tsx" data-component-name="ContactActions" data-component-content="%7B%22elementName%22%3A%22ContactActions%22%7D"
              phone={mockBusiness.phone}
              whatsapp={mockBusiness.whatsapp}
              businessName={mockBusiness.name}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
